import { Check } from "lucide-react";
import { IMG, SERVICES } from "../lib/site";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { RequestQuoteButton, AskExpertButton } from "../components/Buttons";

export default function Services() {
  return (
    <div data-testid="services-page" className="bg-bb-bg">
      <PageHero
        eyebrow="[ What We Do ]"
        title="Services"
        image={IMG.tanker}
        alt="Water tanker truck hauling in the oilfield"
        testid="services-hero"
      />

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <Reveal>
            <p className="max-w-3xl text-bb-silver/70 text-lg md:text-xl leading-relaxed border-l-2 border-bb-gold pl-6">
              Four service lines, one standard: show up on time, do the work
              right, and stand behind it. Here's what Big Buck runs across the
              Delaware Basin.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-5 md:px-10 space-y-24 md:space-y-32">
          {SERVICES.map((s, i) => {
            const reversed = i % 2 === 1;
            return (
              <div
                key={s.num}
                data-testid={`service-row-${i}`}
                className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center"
              >
                <Reveal
                  className={reversed ? "lg:order-2" : ""}
                  y={40}
                >
                  <div className="group relative overflow-hidden aspect-[16/11] grain">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="w-full h-full object-cover hover-spotlight"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-bb-bg/70 via-transparent to-transparent" />
                    <span className="absolute top-5 left-5 font-mono2 text-xs text-bb-gold border border-bb-gold/50 px-3 py-1 bg-bb-bg/60 backdrop-blur">
                      {s.num}
                    </span>
                  </div>
                </Reveal>

                <Reveal delay={0.1} className={reversed ? "lg:order-1" : ""}>
                  <span className="font-display text-bb-gold/30 text-6xl md:text-7xl leading-none block mb-4">
                    {s.num}
                  </span>
                  <h2 className="font-display uppercase text-3xl md:text-5xl text-bb-silver leading-[0.95] mb-5">
                    {s.title}
                  </h2>
                  <p className="text-bb-silver/70 text-lg leading-relaxed mb-7">
                    {s.copy}
                  </p>
                  <ul className="space-y-3">
                    {s.points.map((p, j) => (
                      <li
                        key={j}
                        className="flex items-center gap-3 text-bb-silver/85"
                      >
                        <Check className="h-4 w-4 text-bb-gold shrink-0" />
                        <span className="font-cond uppercase tracking-wide">
                          {p}
                        </span>
                      </li>
                    ))}
                  </ul>
                </Reveal>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA band */}
      <section className="relative py-24 md:py-32 border-t border-white/10 overflow-hidden grain">
        <div className="absolute inset-0 z-0">
          <img src={IMG.grader} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-bb-bg/85" />
        </div>
        <div className="max-w-4xl mx-auto px-5 md:px-10 text-center">
          <Reveal>
            <h2 className="font-display uppercase text-4xl md:text-6xl text-bb-silver leading-[0.95]">
              Need it hauled or graded?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
              <RequestQuoteButton size="lg" testid="services-request-quote-btn" />
              <AskExpertButton size="lg" testid="services-ask-expert-btn" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
